import { z } from 'zod';

const envSchema = z.object({
  VITE_MOCKUP_MODE: z.string().optional().default('false'),
  VITE_CLERK_PUBLISHABLE_KEY: z.string().optional().default(''),
  VITE_API_BASE_URL: z.string().optional().default('/api/v1'),
});

// Single reader of import.meta.env — no other file should access it directly

const parsed = envSchema.parse(import.meta.env);

export const config = Object.freeze({
  mockupMode: parsed.VITE_MOCKUP_MODE === 'true',
  clerkPublishableKey: parsed.VITE_CLERK_PUBLISHABLE_KEY,
  apiBaseUrl: parsed.VITE_API_BASE_URL,
});

export type AppConfig = typeof config;
